import type { SpinResponse } from "@slot/client-engine";
import { baseFixtureReelNoWin } from "./base_fixture_reel_no_win";
import { baseFixtureReelAnticipation } from "./base_fixture_reel_anticipation";
import { baseFixtureReelBigWin } from "./base_fixture_reel_big_win";
import { baseFixtureReelNiceWin } from "./base_fixture_reel_nice_win";
import { baseFixtureReelTumble } from "./base_fixture_reel_tumble";
import { baseFixtureReelCannon } from "./base_fixture_reel_cannon";
import { baseFixtureReelTumbleChain } from "./base_fixture_reel_tumble_chain";
import { baseFixtureReelTumbleLong } from "./base_fixture_reel_tumble_long";
import { baseFixtureReelTumbleDouble } from "./base_fixture_reel_tumble_double";
import { baseFixtureReelTumbleH } from "./base_fixture_reel_tumble_h";
import { baseFixtureReelChance } from "./base_fixture_reel_chance";

/**
 * Base-game fixture playlist (round-robin order) — TUMBLING reels.
 *
 * Every win fixture is a cascade: a cluster/mask win is highlighted, removed, and the grid
 * tumbles (survivors fall + new symbols drop in), re-evaluating until no further win. The
 * non-cascade fixtures kept are the no-win baseline + the anticipation tease. The plain static
 * reel-win fixtures, the payline-era grouped/zigzag fixtures and the legacy 5×6 cascade fixtures
 * were removed (git history, architecture step 1).
 *
 * The order is hand-tuned for playing offline, so some fixtures come round twice; the e2e suite
 * pins by id every round whose content it checks.
 */
export function createBaseFixtures(): SpinResponse[] {
  return [
    baseFixtureReelChance(),       // CHANCE: H1 ×6 (cannon x2), then a dead grid whose CH detonates its 8 neighbours → L5 ×6 (x3)
    baseFixtureReelAnticipation(), // near-miss anticipation tease (server-flagged reels 4 + 5)
    baseFixtureReelCannon(),       // CANNON: 2-step cascade, fires x2 then x3 (growing multiplier)
    baseFixtureReelBigWin(),       // tiered BIG WIN reached by a cascade (nice→big→huge→epic)
    baseFixtureReelTumble(),       // single-step L1 cluster tumble (validation)
    baseFixtureReelChance(),       // CHANCE again
    baseFixtureReelTumbleChain(),  // 2-step cascade chain (L2 → L1), WinMeter counts 0→200→500
    baseFixtureReelTumbleH(),      // single-step HIGH-symbol (H2) tumble — alt-frame win variety
    baseFixtureReelNiceWin(),      // "nice" big-win tier reached by a tumble (10×: dim + number only)
    baseFixtureReelTumbleDouble(), // two clusters removed in ONE step (L4 + L2)
    baseFixtureReelNoWin(),        // no-win baseline spin
    baseFixtureReelTumbleLong(),   // 3-step cascade, cannon x2→x3→x4, WinMeter 0→200→500→660
    baseFixtureReelAnticipation(), // near-miss anticipation tease (server-flagged reels 4 + 5)
    baseFixtureReelBigWin(),       // tiered BIG WIN reached by a cascade (nice→big→huge→epic)
    baseFixtureReelNoWin(),
  ];
}
